// removed by extract-text-webpack-plugin
module.exports = {"full-scorecard":"full-scorecard___3MnCo","card":"card___3eaIs shadow-broad___37axf","scorecard-header":"scorecard-header___s2TDE h3___5u0xZ"};